export const TURBINES_KEY = 'turbines';

export const turbinesKey = {
  all: [TURBINES_KEY],
  lists: token => [...turbinesKey.all, 'list', token],
  turbinesList: token => [...turbinesKey.all, 'turbines-list', token],
  detail: (token, locationId) => [
    ...turbinesKey.all,
    'detail',
    token,
    locationId
  ],
  turbineDetail: (token, turbineId) => [
    ...turbinesKey.all,
    'turbine-detail',
    token,
    turbineId
  ],
  historySeries: (token, params) => [
    ...turbinesKey.all,
    'history-series',
    token,
    params
  ],
  turbineSummary: (token, turbineId) => [
    ...turbinesKey.all,
    'turbine-summary',
    token,
    turbineId
  ],
  auditingReport: (token, request) => [
    ...turbinesKey.all,
    'auditing-report',
    token,
    request
  ]
};
